import api from './api';
import { nullableUuid } from '@/utils/uuid';

export type StatusPagamento = 'PENDENTE' | 'PAGO' | 'ATRASADO' | 'CANCELADO';

export interface HistoricoPagamento {
  id: string;
  empresa_id: string;
  mes_referencia: string;
  valor: number;
  data_vencimento: string;
  data_pagamento?: string | null;
  status: StatusPagamento;
  forma_pagamento?: string | null;
  observacoes?: string | null;
  comprovante?: string | null;
  usuario_cadastro?: string | null;
}

export interface HistoricoPagamentoInput {
  empresa_id: string;
  mes_referencia: string;
  valor: number;
  data_vencimento: string;
  data_pagamento?: string | null;
  status: StatusPagamento;
  forma_pagamento?: string | null;
  observacoes?: string | null;
}

const ENDPOINT = '/historico-pagamentos';

const historicoPagamentoService = {
  async criar(data: HistoricoPagamentoInput): Promise<HistoricoPagamento> {
    const response = await api.post<HistoricoPagamento>(ENDPOINT, { ...data, empresa_id: nullableUuid(data.empresa_id) });
    return response.data;
  },
  async confirmarPagamento(id: string, data: { data_pagamento?: string; forma_pagamento?: string; observacoes?: string }): Promise<{ message: string; nova_data_vencimento: string }> {
    const response = await api.post(`${ENDPOINT}/${id}/confirmar_pagamento`, data);
    return response.data;
  },
};

export default historicoPagamentoService;
